import memoizee from 'memoizee'

import { useBreakpoints as _useBreakpoints } from '@vueuse/core'

import { breakpoints } from '../consts'
import { getScaledPx } from '../utils'

const memoizedUseBreakpoints = memoizee(() => {
  const breakpointsTailwindScaled = Object.fromEntries(
    Object.entries(breakpoints).map(([key, value]) => [
      key,
      getScaledPx(value),
    ]),
  )

  return _useBreakpoints(breakpointsTailwindScaled)
})

/**
 * tailwind breakpoints as reactive composable, useful when css breakpoint classes are not enough
 */
// eslint-disable-next-line
export function useBreakpoints() {
  const breakpoints = memoizedUseBreakpoints()

  return { breakpoints }
}
